import React, {PropTypes} from 'react';
import ContentItemAction from './ContentItemAction';

const BookItem = ({item, img}) => {

  const style = {
    imgContainer: {
      width: "150px",
      height: "250px",
      border: "1px solid #bdb8b8",
      backgroundImage: 'url(' + img + ')',
      backgroundSize: "150px 250px",
      backgroundRepeat: "no-repeat",
      cursor: "pointer"
    }
  };

  return (
    <ContentItemAction>
      <div
        style={style.imgContainer}
        item={item}
        >
      </div>
    </ContentItemAction>
  );
};

BookItem.propTypes = {
  item: PropTypes.shape({
    url: PropTypes.string
  }),
  img: PropTypes.string
};

export default BookItem;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/BookItem.js
 **/